export interface PlaceOfServiceValues {
  placeName: string;
  phoneNumber: string;
  postalCode: string;
  address: string;
  houseNumber: string;
  district: string;
  complement: string;
  city: string;
  state: string;
}

export const defaultPlaceOfServiceData: PlaceOfServiceValues = {
  placeName: '',
  phoneNumber: '',
  postalCode: '',
  address: '',
  houseNumber: '',
  district: '',
  complement: '',
  city: '',
  state: '',
};

export interface ImportDataValues {
  needsHelp: boolean;
}

export const defaultImportDataValues: ImportDataValues = {
  needsHelp: false,
};
